import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";
import { HomepageProtocolBenefits } from "@/design-system/patterns/homepage-protocol-benefits";
import { HomepageConsoleShowcase } from "@/design-system/patterns/homepage-console-showcase";

export default function VisionPageEn() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItemsEn} actionItems={siteHeaderActionsEn} homeHref="/en" />
      <main className="relative z-10 w-full overflow-hidden">
        <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-5xl">
            <div className="mb-8">
              <BrutalistBadge bgClass="bg-[#8B5CF6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
                VISION
              </BrutalistBadge>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
              Long-term Vision
            </h1>
            <p className="text-lg font-bold text-zinc-600 mb-8">
              This page describes CALL ANYTHING's long-term direction. These are not currently available features.
            </p>
            <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
              <p className="text-sm font-bold text-zinc-800">
                ⚠️ Everything on this page is a long-term plan or proof of concept—not the current product state. For current features, see the <a href="/en" className="underline font-black">homepage</a>.
              </p>
            </div>

            {/* Network Effect Vision */}
            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">Network Effects</h2>
              <p className="text-sm text-zinc-700">
                When enough Hotlines go live and get called repeatedly, network effects kick in: more Callers mean higher revenue for Responders; more Responders mean richer capabilities for Callers. This is the classic positive feedback loop of a two-sided marketplace.
              </p>
              <div className="grid gap-4 sm:grid-cols-3">
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">Supply Side</h3>
                  <p className="text-xs text-zinc-600 mt-1">Individuals package expertise into Hotlines, billed per call.</p>
                </div>
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">Demand Side</h3>
                  <p className="text-xs text-zinc-600 mt-1">Agents discover and invoke external capabilities via catalog.</p>
                </div>
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">Protocol Layer</h3>
                  <p className="text-xs text-zinc-600 mt-1">Standardized contracts eliminate bilateral integration.</p>
                </div>
              </div>
            </div>

            {/* Evolution Path */}
            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">OPC Evolution Path</h2>
              <div className="flex flex-wrap gap-3">
                {evolutionSteps.map((step, idx) => (
                  <div key={step.stage} className="border-4 border-black bg-white/85 p-3 shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]">
                    <span className="text-xs font-black text-zinc-400">Stage {idx + 1}</span>
                    <p className="font-black text-sm">{step.stage}</p>
                    <p className="text-xs text-zinc-600">{step.meta}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <HomepageProtocolBenefits />
        <HomepageConsoleShowcase />
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}

const evolutionSteps = [
  { stage: "One Hotline", meta: "Solo operator" },
  { stage: "Repeatedly called", meta: "Active monthly usage" },
  { stage: "Revenue covers ops", meta: "Break-even" },
  { stage: "Team up", meta: "2–3 person crew" },
  { stage: "Stable service node", meta: "Incorporated" },
];
